import { css } from '@emotion/react'
import { ExternalStyles, Theme, useTheme } from 'bold-ui'
import { useState } from 'react'

import pausedImg from '../../../images/novidades/icons/pause.webp'

interface NewsGifProps {
  src: string
  alt: string
  pausedSrc: string
  width?: number
  height?: number
  customStyles?: ExternalStyles
}

export const NewsGif = (props: NewsGifProps) => {
  const { alt, src, pausedSrc, width, height, customStyles } = props
  const [isPlaying, setIsPlaying] = useState(false)
  const theme = useTheme()
  const classes = styles(theme)

  const togglePlaying = () => {
    setIsPlaying(!isPlaying)
  }

  const renderAnimation = () =>
    src.endsWith('.webm') ? (
      <video src={src} css={classes.imageGif} autoPlay loop muted playsInline />
    ) : (
      <img src={src} alt={alt} width={width} height={height} css={classes.imageGif} />
    )

  return (
    <div css={[classes.container, customStyles]} onClick={togglePlaying}>
      {isPlaying ? (
        renderAnimation()
      ) : (
        <img src={pausedSrc} alt={alt} width={width} height={height} css={classes.imageGif} />
      )}
      {!isPlaying && <img src={pausedImg} alt='Imagem de pause' css={classes.pausedImg} />}
    </div>
  )
}

const styles = (theme: Theme) => ({
  container: css`
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100%;
    max-height: 430px;
    position: relative;
    cursor: pointer;
  `,
  imageGif: css`
    max-width: 100%;
    max-height: 430px;
    height: auto;
    image-rendering: -webkit-optimize-contrast;
    border: 1px solid ${theme.pallete.gray.c80};
    border-radius: ${theme.radius.button}px;
  `,
  pausedImg: css`
    position: absolute;
    left: 45%;
    top: 42%;
    width: 80px;
    height: 80px;
  `,
})
